import type {
  CloneTemplateResponse,
  CreateTemplateRequest,
  CreateTemplateResponse,
  TemplateApiResponse,
  UpdateTemplateRequest,
} from "./types";
import { ApiEndpoints } from "@shared/api/api-endpoints";
import { communicationApiClient } from "@shared/api/clients/apiClientFactory";

export const communicationTemplateApi = {
  getTemplatesFilter: async (
    utilityId: string,
    page: number,
    page_size: number,
    channelType?: string,
    category?: string,
    isDraft?: boolean,
    tags?: string,
    searchData?: string
  ): Promise<TemplateApiResponse> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "communication",
      "template",
      (query) => {
        query.push("remote_utility_id", utilityId.toString());
        query.push("page", page.toString());
        query.push("page_size", page_size.toString());
        if (channelType) query.push("channel_type", channelType);
        if (category) query.push("template_category", category);
        if (isDraft !== undefined) query.push("is_draft", isDraft.toString());
        if (tags) query.push("tags", tags);
        if (searchData) query.push("search_data", searchData);
      }
    );
    const response = await communicationApiClient.get(url);
    return response.data;
  },

  async createTemplate(
    templateData: CreateTemplateRequest
  ): Promise<CreateTemplateResponse> {
    const url = ApiEndpoints.createUrl("communication", `template`);
    const response = await communicationApiClient.post(url, templateData);
    return response.data;
  },

  updateTemplate: async (
    templateId: number,
    templateData: UpdateTemplateRequest
  ): Promise<any> => {
    const url = ApiEndpoints.createUrl(
      "communication",
      `template/${templateId}`
    );
    const response = await communicationApiClient.patch(url, templateData);
    return response.data;
  },
  async getTemplatePlaceHolders(
    placeholderKeys: boolean,
    placeholderCategory: string
  ): Promise<string[]> {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "communication",
      `choices/placeholders`,
      (query) => {
        query.push("placeholder_keys", placeholderKeys.toString());
        query.push("placeholder_category", placeholderCategory);
      }
    );
    const response = await communicationApiClient.get(url);
    return response.data.result;
  },

  async cloneTemplate(templateId: number): Promise<CloneTemplateResponse> {
    const url = ApiEndpoints.createUrl(
      "communication",
      `template-clone/${templateId}`
    );
    const response = await communicationApiClient.put(url, undefined);
    return response.data;
  },
  toggleTemplateStatus: async (templateId: number, isActive: boolean) => {
    const url = ApiEndpoints.createUrl(
      "communication",
      `template/${templateId}`
    );
    const response = await communicationApiClient.patch(url, {
      is_active: isActive,
    });
    return response.data;
  },
};
